import React, { Component } from 'react'
import './main.css'

class NumberInput extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isEmpty: false,
            isNotNumber: false
        }
    }

    async validateInput() {
        if (!this.lookIfNumber()) {
            await this.setState({ isEmpty: false, isNotNumber: true })
            return false
        } else {
            await this.setState({ isEmpty: false, isNotNumber: false })
            return true
        }
    }

    lookIfNumber() {
        if (isNaN(Number(this.props.value))) return false

        return true
    }

    render() {
        return (
            <React.Fragment>
                <label className="data-label"><strong>{this.props.labelStrong}</strong>{this.props.labelNormal}</label><br></br>
                <input type="text" value={this.props.value} onChange={async e => {await this.props.onChange(e, this.props.stateProp); await this.validateInput()}} className="data-text-input small-data-text"></input><br></br>
                {this.state.isEmpty && <p className="text-input-error-p" >{this.props.label} boş bırakılamaz</p>}
                {this.state.isNotNumber && <p className="text-input-error-p" >{this.props.labelStrong} sadece sayı değerleri içermelidir</p>}
            </React.Fragment>
        )
    }
}

export default NumberInput